import { selectUserState, userActions } from "app/store/slices/user";
import { useAppDispatch, useAppSelector } from "app/store/store";
import type { NextPage } from "next";
import Head from "next/head";
import React, { useEffect } from "react";
import Loader from "app/components/icons/Loader";
import styles from "./spotify.module.scss";
import { useRouter } from "next/router";
import { postPillowUserV2UsersMeSpotify } from "services-hooks/services";
import { useTranslate } from "app/hooks/lang";
import { useNavigatePath } from "app/hooks/navigation.hook";
import useMetaDescription from "app/utils/getMetaDescription";

const Spotify: NextPage = () => {
  const navigatePath = useNavigatePath();
  const router = useRouter();
  const { code, spotifyError } = router.query;
  const dispatch = useAppDispatch();
  const { session } = useAppSelector(selectUserState);
  const getMetaDescription = useMetaDescription();
  console.log({ session, code, spotifyError });
  useEffect(() => {
    if (session?.user?.spotify_connect) {
      navigatePath("/settings");
    }
  }, [session?.user?.spotify_connect]);

  const sendRequest = async () => {
    if (code) {
      try {
        const data = await postPillowUserV2UsersMeSpotify({
          spotify_code: code as string,
          redirect_uri: `${window.location.origin}/spotify/`,
        });
        if (data) {
          dispatch(userActions.setUser(data.data.data));
        }
      } catch (e) {
        console.log("ERROR");
      } finally {
        navigatePath("/settings");
      }
    }
  };

  useEffect(() => {
    if (
      !spotifyError &&
      code &&
      session?.user &&
      !session?.user?.spotify_connect
    ) {
      console.log("SEND REQUEST");
      sendRequest();
    }
  }, [code, spotifyError, session?.user]);
  const t = useTranslate();

  return (
    <div className={styles.container}>
      <Head>
        <title>Spotify - Radioline</title>
        {getMetaDescription(t("settings.meta-description"))}
      </Head>
      <div className={styles.wrapper}>
        <Loader />
      </div>
    </div>
  );
};

export default Spotify;
